import { gql } from 'urql';

// HardPull Submit Application
const LineOfCreditSubmitApplication = gql`
  mutation lineOfCreditSubmitApplication(
    $idempotencyId: IdempotencyToken!
    $input: LineOfCreditSubmitApplicationInput!
  ) {
    lineOfCreditSubmitApplication(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      ... on LineOfCreditSubmitApplicationSuccess {
        applicationId
      }
      ... on LineOfCreditSubmitApplicationError {
        code
        message
        title
      }
    }
  }
`;

export default LineOfCreditSubmitApplication;
